import React from "react";
import { RouteObject } from "react-router";

export const DocumentRoutes: RouteObject[] = [
  {
    path: "layout",
    async lazy() {
      const { Layout } = await import(
        /* webpackChunkName: "orgs-cache-layout" */ "orgs/Configuration/DocumentsTab/Layout"
      );
      return {
        element: <Layout />,
      };
    },
    children: [
      {
        path: ":documentType",
        async loader(args) {
          const { documentsLoader } = await import(
            /* webpackChunkName: "orgs-cache-documents-loader" */ "src/router/loaders/orgs/Documents"
          );
          return documentsLoader(args);
        },
        shouldRevalidate: () => true,
        async lazy() {
          const { AddDocumentModal } = await import(
            /* webpackChunkName: "orgs-cache-add-document-modal" */ "orgs/Configuration/DocumentsTab/Layout/AddDocumentModal"
          );
          return {
            element: <AddDocumentModal />,
          };
        },
      },
    ],
  },
  {
    path: "configuration",
    async loader(args) {
      const { configurationLoader } = await import(
        /* webpackChunkName: "orgs-cache-configuration-loader" */ "src/router/loaders/orgs/Documents"
      );
      return configurationLoader(args);
    },
    async lazy() {
      const { DocumentConfiguration } = await import(
        /* webpackChunkName: "orgs-cache-document-configuration" */ "orgs/Configuration/DocumentsTab/DocumentConfiguration"
      );
      return {
        element: <DocumentConfiguration />,
      };
    },
  },
  {
    path: "signature",
    async lazy() {
      const { Signature } = await import(
        /* webpackChunkName: "orgs-cache-signature" */ "orgs/Configuration/DocumentsTab/Signature"
      );
      return {
        element: <Signature />,
      };
    },
    children: [
      {
        path: ":signatureIndex",
        async lazy() {
          const { EditModal } = await import(
            /* webpackChunkName: "orgs-cache-edit-modal" */ "orgs/Configuration/DocumentsTab/Signature/EditModal"
          );
          return {
            element: <EditModal />,
          };
        },
      },
    ],
  },
  {
    path: "patterns",
    async loader(args) {
      const { orgPatternsLoader } = await import(
        /* webpackChunkName: "orgs-cache-patterns-loader" */ "src/router/loaders/orgs/Documents"
      );
      return orgPatternsLoader(args);
    },
    async lazy() {
      const { Patterns } = await import(
        /* webpackChunkName: "orgs-cache-patterns" */ "orgs/Configuration/DocumentsTab/Patterns"
      );
      return {
        element: <Patterns />,
      };
    },
    children: [
      {
        path: ":patternId",
        async loader(args) {
          const { orgPatternLoader } = await import(
            /* webpackChunkName: "orgs-cache-pattern-loader" */ "src/router/loaders/orgs/Documents"
          );
          return orgPatternLoader(args);
        },
        async lazy() {
          const { EditPattern } = await import(
            /* webpackChunkName: "orgs-cache-edit-pattern" */ "src/settings/PatternsTab/EditPattern"
          );
          return { element: <EditPattern /> };
        },
      },
      {
        path: "copy/:copyPatternId",
        async loader(args) {
          const { copyOrgPatternLoader } = await import(
            /* webpackChunkName: "orgs-cache-copy-pattern-loader" */ "src/router/loaders/orgs/Documents"
          );
          return copyOrgPatternLoader(args);
        },
        async lazy() {
          const { EditPattern } = await import(
            /* webpackChunkName: "orgs-cache-edit-pattern-copy" */ "src/settings/PatternsTab/EditPattern"
          );
          return { element: <EditPattern /> };
        },
      },
    ],
  },
  {
    path: "",
    async loader(args) {
      const { documentsLoader } = await import(
        /* webpackChunkName: "orgs-cache-all-documents-loader" */ "src/router/loaders/orgs/Documents"
      );
      return documentsLoader(args);
    },
    async lazy() {
      const { AllDocuments } = await import(
        /* webpackChunkName: "orgs-cache-all-documents" */ "orgs/Configuration/DocumentsTab/AllDocuments"
      );
      return {
        element: <AllDocuments />,
      };
    },
    children: [
      {
        path: ":documentId/edit",
        async lazy() {
          const { EditDocumentModal } = await import(
            /* webpackChunkName: "orgs-cache-edit-document-modal" */ "orgs/Configuration/DocumentsTab/AllDocuments/EditDocumentModal"
          );
          return {
            element: <EditDocumentModal />,
          };
        },
      },
    ],
  },
];
